import script from "./SpotLight.vue?vue&type=script&setup=true&lang=js"
export * from "./SpotLight.vue?vue&type=script&setup=true&lang=js"

import "./SpotLight.vue?vue&type=style&index=0&id=ff16c47e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff16c47e"]])

export default __exports__